import { c } from '#/shared/lib/helpers'
import styles from './common-button.module.scss'

export type ButtonVariant = 'outline' | 'primary' | 'primary-outline' | 'gray'

export interface CommonButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	children?: React.ReactNode
	variant?: ButtonVariant
}

export const CommonButton = ({ children, variant = 'outline', className, disabled, ...props }: CommonButtonProps) => {
	return (
		<button
			className={c(
				styles.button,
				styles[`button_${variant}`],
				disabled && styles[`button_${variant}_disabled`],
				className
			)}
			disabled={disabled}
			{...props}
		>
			{children}
		</button>
	)
}
